import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import { captureConsoleLogs } from '../utils/consoleLogging';

// 1. Initialize the Provider
export const initTelemetry = () => {
  // Use resourceFromAttributes instead of new Resource() as Resource is an interface in this version
  const resource = resourceFromAttributes({
    [ATTR_SERVICE_NAME]: 'intentico-frontend',
    'deployment.environment': import.meta.env.VITE_ENVIRONMENT || 'development',
  });

  // 2. Configure the Exporter to point to YOUR Vercel Proxy
  const exporter = new OTLPTraceExporter({
    url: '/api/logfire-proxy', // Relative path to your Vercel function
  });

  const provider = new WebTracerProvider({
    resource: resource,
    spanProcessors: [new BatchSpanProcessor(exporter)],
  });
  
  // 3. Register the provider
  provider.register({
    contextManager: new ZoneContextManager(),
  });

  // 4. (Optional) Capture Console Logs
  captureConsoleLogs(provider.getTracer('console-logger'));
  
  return provider;
};
